import styled from "styled-components";
import { useContext, useState } from "react";
import { ProjectsContext } from "providers/ProjectsProvider";
import { useNavigate } from "react-router-dom";
import { Topbar } from "components/ui/shared/Topbar";
import { Button } from "components/ui/controls/Button";

import { SearchBar } from "components/ui/inputs/SearchBar";
import { DropdownMenu, DropdownOption } from "components/ui/inputs/DropdownMenu";

import { ViewSwitch } from "components/ui/controls/ViewSwitch";
import { DragDropProvider } from "@dnd-kit/react";
import { ArchiveDropZone } from "components/ui/controls/ArchiveDropZone";
import { useErrors } from "providers/ErrorsProvider";
import { ProjectsKanban } from "components/features/projects/ProjectsKanban";
import { ProjectsList } from "components/features/projects/ProjectsList";
import { projectsDragHandler } from "utilities/dragAndDropHandlers";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const Projects = () => {

    const navigate = useNavigate();

    const { setError } = useErrors()

    const [projectsView, setProjectsView] = useState(() => {return localStorage.getItem("projectsViewStyle") || 'grid'});
    const [projectsFilters, setProjectsFilter] = useState({search: '', region: null, content: null});
    const [isDraggingActive, setIsDraggingActive] = useState(false);
    const { projects, handleProjectEdit } = useContext(ProjectsContext);
    
    const onDragStart = (e) => {
        setIsDraggingActive(true);
    }

    const onDragEnd = async (e) => {

        const res = await projectsDragHandler(e, handleProjectEdit);
        if(res?.status) setError(res.reason);

        setIsDraggingActive(false);

    }

    const filterProjects = () => {
        let prjs = projects.map(prj => {
            let searchFilter = true;
            let contentFilter = true;
            let regionFilter = true;

            if(!prj.projectName.includes(projectsFilters.search)) searchFilter = false;

            if(projectsFilters.content)
            {
                if(!prj.projectContent.enabled || !prj.projectContent[projectsFilters.content]) contentFilter = false;
            }

            if(projectsFilters.region)
            {
                if(prj.projectMap.county !== projectsFilters.region) regionFilter = false;
                
            }

            if(searchFilter && contentFilter && regionFilter) return prj;
            else return null;

        });
        return prjs;
    }

    return (
        <>
            <Topbar breacrumb={['Prosjekter']}>
                <Button
                    type='primary'
                    text="Ny prosjekt"
                    prefix={<MaterialIcon name='add' weight={300}/>}
                    onClick={() => navigate('/projects/new')}
                />
            </Topbar>
            <StyledProjectsContainer>
                <div className="projectsHeader">
                    <span className="title">
                        Prosjektportefølje
                    </span>
                    <div className="options">
                        <div>
                            <SearchBar placeholder={"Søk i prosjekter..."} onChange={(e) => setProjectsFilter(prev => ({...prev, search: e.target.value.trim()}))}/>
                            <DropdownMenu defaultIcon={<MaterialIcon name='map' weight={300}/>} defaultName="Region" defaultValue={null} onSelect={(e) => setProjectsFilter(prev => ({...prev, region: e ? e : null}))}>
                                <DropdownOption name='Agder' value='Agder'/>
                                <DropdownOption name='Akerhus' value='Akerhus'/>
                                <DropdownOption name='Buskerud' value='Buskerud'/>
                                <DropdownOption name='Finnmark' value='Finnmark'/>
                                <DropdownOption name='Innlandet' value='Innlandet'/>
                                <DropdownOption name='Møre og Romsdal' value='Møre og Romsdal'/>
                                <DropdownOption name='Nordland' value='Nordland'/>
                                <DropdownOption name='Oslo' value='Oslo'/>
                                <DropdownOption name='Rogaland' value='Rogaland'/>
                                <DropdownOption name='Telemark' value='Telemark'/>
                                <DropdownOption name='Troms' value='Troms'/>
                                <DropdownOption name='Trøndelag' value='Trøndelag'/>
                                <DropdownOption name='Vestfold' value='Vestfold'/>
                                <DropdownOption name='Vestland' value='Vestland'/>
                                <DropdownOption name='Østfold' value='Østfold'/>
                                <DropdownOption icon={<MaterialIcon name='close' weight={300}/>} name='Tøm filter' value={null}/>
                            </DropdownMenu>

                            <DropdownMenu defaultIcon={<MaterialIcon name='bookmark' weight={300}/>} defaultName="Innhold" defaultValue={null} onSelect={(e) => setProjectsFilter(prev => {return {...prev, content: e}})}>
                                <DropdownOption icon={<MaterialIcon name='road' weight={300}/>} name='Vegplanlegging' value='road'/>
                                <DropdownOption icon={<MaterialIcon name='directions' weight={300}/>} name='Skilt og vegoppmerking' value='sign'/>
                                <DropdownOption icon={<MaterialIcon name='traffic' weight={300}/>} name='Signal og trafikkstyring' value='signal'/>
                                <DropdownOption icon={<MaterialIcon name='traffic_jam' weight={300}/>} name='Trafikkteknikk' value='traffic'/>
                                <DropdownOption icon={<MaterialIcon name='outdoor_garden' weight={300}/>} name='Trafikksikkerhet' value='safety'/>
                                <DropdownOption icon={<MaterialIcon name='brick' weight={300}/>} name='BIM' value='bim'/>
                                <DropdownOption icon={<MaterialIcon name='3d' weight={300}/>} name='3D Modeller' value='models3d'/>
                                <DropdownOption icon={<MaterialIcon name='draft' weight={300}/>} name='Dokumentarbeid' value='document'/>
                                <DropdownOption icon={<MaterialIcon name='close' weight={300}/>} name='Tøm filter' value={null}/>
                            </DropdownMenu>
                        </div>
                        <div>
                            <ViewSwitch
                                firstOptionName="Fliser"
                                firstOptionIcon={<MaterialIcon name='grid_view' weight={300}/>}
                                firstOptionValue="grid"

                                secondOptionName="Liste"
                                secondOptionIcon={<MaterialIcon name='list' weight={300}/>}
                                secondOptionValue="list"

                                selected={projectsView}
                                onChange={(e) => {setProjectsView(e); localStorage.setItem("projectsViewStyle", e)}}
                            />
                        </div>
                    </div>
                </div>
                <div className="projectsContent">
                    <DragDropProvider onDragStart={onDragStart} onDragEnd={onDragEnd}>
                        {
                            projectsView === 'grid'
                            ? <ProjectsKanban projects={filterProjects()}/>
                            : <ProjectsList projects={filterProjects()}/>
                        }
                        <ArchiveDropZone isActive={isDraggingActive}/>
                    </DragDropProvider>
                </div>
            </StyledProjectsContainer>
        </>
    )
}

const StyledProjectsContainer = styled.div`
    padding-left: ${({theme}) => theme.spacing.xl};
    padding-right: ${({theme}) => theme.spacing.xl};
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    div.projectsHeader 
    {
        margin-bottom: ${({theme}) => theme.spacing.lg};

        span.title
        {
            font-size: ${({theme}) => theme.fontSize.xxl};
            font-weight: 500;
            display: block;
            margin-bottom: ${({theme}) => theme.spacing.lg};
        }

        div.options
        {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: ${({theme}) => theme.spacing.md};
            

            > div
            {
                display: flex;
                gap: ${({theme}) => theme.spacing.md};
            }
        }
    }

    div.projectsContent
    {
        flex: 1 1 auto;
        overflow: auto;
    }
`
